<template>
  <div class="container-xl">

    <div class="hade">
      <router-link to="/"
        ><img src="../img/button icon@2x2.png" alt="" />&nbsp;首页</router-link
      >
    </div>
    <div class="success">
      <img src="../img/steps@2x.png" alt="" />
      <h2>成功预约口腔扫描</h2>
      <img src="../img/star line@2x.png" alt="" />
    </div>
    <!-- <div class="time">
        <h5>
          日期&nbsp;&nbsp;
          <span style="color: #323e48">{{ time.date }}</span>
        </h5>
        <h5>
          時段&nbsp;&nbsp;
          <span style="color: #323e48"
            ><span v-if="time.start - 1 < 12">
              上午{{ time.start }}:00-上午{{ parseInt(this.time.start) + 1 }}:00
            </span>
            <span v-if="time.start > 12">
              下午{{ time.start }}:00-下午{{ parseInt(this.time.start) + 1 }}:00
            </span></span
          >
        </h5>
      </div>
      <div class="clinic">
        <h4>{{ city.name }}</h4>
        <p>就診時間 : {{ city.BH }}</p>
        <p>聯繫電話 : {{ city.phone }}</p>
        <p>地址 : {{ city.address }}</p>
      </div>
      <div class="data">
        <h5>
          姓名&nbsp;&nbsp;<span style="color: #323e48">{{
            liaison.userName
          }}</span>
        </h5>
        <h5>
          手機&nbsp;&nbsp;<span style="color: #323e48">{{
            liaison.userPhone
          }}</span>
        </h5>
        <h5>
          電郵&nbsp;&nbsp;<span style="color: #323e48">{{ liaison.mail }}</span>
        </h5>
        <p>
          檢查流程需要大約1小時，包括口腔掃描、結果分析及專家建議。
          請提前10分鐘到達，以便儘快開始檢查。
        </p>
        <h3>完成口腔掃描後，你將在3天內收到量身定制的矯正計畫</h3>
      </div> -->
    <!-- <div class="row">
      <div class="col-lg-6 Reserve">
        <h2>實名預約</h2>
        <p>
          由於預約量將滿額，為避免公共預約資源浪費，<br />
          請輸入您的信用卡詳細資訊實名預約，<br />實名預約之後您若需改期，<br />不會另外收取HK$25的費用。
        </p>
      </div>
      <div class="col-lg-6 pay">
       
      </div>
    </div> -->
    <div class="row map">
      <div class="col-lg-6 name">
        <h2>{{ city.name }}</h2>
        <p>{{ city.address }}</p>
        <p>{{ city.phone }}</p>
      </div>
      <div class="col-lg-6 position">
        <img :src="city.img" alt="" />
      </div>
    </div>
  </div>
</template>

<script>
// import { Checkout } from "../pay/Checkout.js";
export default {

  metaInfo:{
    link:[{
      rel:'canonical',
      href:'https://mybeame.com/complete'
    },{
      rel:'alternate',
      href:'https://mybeame.com/complete',
      hrefLang:'x-default'
    }
    ]
  },

  data() {
    return {
      city: [{}],
      liaison: [{}],
      time: [{}],
    };
  },
  mounted() {
    this.liaison = JSON.parse(localStorage.getItem("liaison")); //获取本地数据
    this.city = JSON.parse(localStorage.getItem("city"));
    this.time = JSON.parse(localStorage.getItem("time"));
  },
  methods: {},
};
</script>
<style scoped>
/* Variables */
* {
  box-sizing: border-box;
}

body {
  font-family: -apple-system, BlinkMacSystemFont, sans-serif;
  font-size: 16px;
  -webkit-font-smoothing: antialiased;
  display: flex;
  justify-content: center;
  align-content: center;
  height: 100vh;
  width: 100vw;
}

form {
  width: 77%;
  align-self: center;
  box-shadow: 0px 0px 0px 0.5px rgba(50, 50, 93, 0.1),
    0px 2px 5px 0px rgba(50, 50, 93, 0.1), 0px 1px 1.5px 0px rgba(0, 0, 0, 0.07);
  border-radius: 7px;
  padding: 40px;
}

.hidden {
  display: none;
}

#payment-message {
  color: rgb(105, 115, 134);
  font-size: 16px;
  line-height: 20px;
  padding-top: 12px;
  text-align: center;
}

#payment-element {
  margin-bottom: 24px;
}

/* Buttons and links */
button {
  background: #5469d4;
  font-family: Arial, sans-serif;
  color: #ffffff;
  border-radius: 4px;
  border: 0;
  padding: 12px 16px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  display: block;
  transition: all 0.2s ease;
  box-shadow: 0px 4px 5.5px 0px rgba(0, 0, 0, 0.07);
  width: 100%;
}
button:hover {
  filter: contrast(115%);
}
button:disabled {
  opacity: 0.5;
  cursor: default;
}

/* spinner/processing state, errors */
/* .spinner,
.spinner:before,
.spinner:after {
  border-radius: 50%;
}
.spinner {
  color: #ffffff;
  font-size: 22px;
  text-indent: -99999px;
  margin: 0px auto;
  position: relative;
  width: 20px;
  height: 20px;
  box-shadow: inset 0 0 0 2px;
  -webkit-transform: translateZ(0);
  -ms-transform: translateZ(0);
  transform: translateZ(0);
}
.spinner:before,
.spinner:after {
  position: absolute;
  content: "";
}
.spinner:before {
  width: 10.4px;
  height: 20.4px;
  background: #5469d4;
  border-radius: 20.4px 0 0 20.4px;
  top: -0.2px;
  left: -0.2px;
  -webkit-transform-origin: 10.4px 10.2px;
  transform-origin: 10.4px 10.2px;
  -webkit-animation: loading 2s infinite ease 1.5s;
  animation: loading 2s infinite ease 1.5s;
}
.spinner:after {
  width: 10.4px;
  height: 10.2px;
  background: #5469d4;
  border-radius: 0 10.2px 10.2px 0;
  top: -0.1px;
  left: 10.2px;
  -webkit-transform-origin: 0px 10.2px;
  transform-origin: 0px 10.2px;
  -webkit-animation: loading 2s infinite ease;
  animation: loading 2s infinite ease;
} */

/* @-webkit-keyframes loading {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@keyframes loading {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@media only screen and (max-width: 1200px) {
  form {
    width: 90%;
    min-width: initial;
    margin: auto;
  }
}
@media only screen and (max-width: 992px) {
  form {
    width: 95%;
  }
}

@media only screen and (max-width: 570px) {
  form {
    width: 95%;
  }
} */
.container-xl {
  padding: 0;
}
.row {
  margin: 0;
  background-color: #f2f2f2;
}
.hade {
  width: 100%;
  padding: 10px 0;
  margin-top: 50px;
  background: linear-gradient(90deg, #36ff94 0%, #00e467 100%);
}
.hade > a {
  margin-left: 20px;
  font-weight: 700;
  display: flex;
  font-size: 20px;
}
.hade > a > img {
  width: 19px;
  height: 28px;
}
.success {
  text-align: center;
  padding: 20px 0;
  background-color: #f2f2f2;
}
.success img:nth-child(1) {
  width: 50px;
  height: 50px;
  margin-bottom: 10px;
}
.success img:nth-child(3) {
  width: 150px;
  height: 28px;
  margin-top: 10px;
}
.success > h2 {
  font-size: 34px;

  font-weight: 700;
  margin-bottom: 10px;
}

.time {
  border-bottom: 1px solid #cccccc;
  padding: 25px 20px 15px 20px;
}
.time > h3 {
  font-size: 1.4rem;
  font-weight: 700;
  margin-bottom: 25px;
}
.time > h5 {
  display: flex;
  align-items: center;
  font-size: 21px;
  margin-bottom: 10px;
  color: #a0a0a0;
}
.clinic {
  border-bottom: 1px solid #cccccc;
  padding: 25px 20px 15px 20px;
}
.clinic > h4 {
  font-size: 23px;
  font-weight: 600;
}
.clinic > p {
  margin-bottom: 5px;
  color: #a0a0a0;
  font-size: 19px;
}
.data {
  padding: 25px 20px 30px 20px;
}
.data > h5 {
  display: flex;
  align-items: center;
  font-size: 21px;
  margin-bottom: 10px;
  color: #a0a0a0;
}
.data > p {
  margin-top: 40px;
  color: #676767;
  font-size: 20px;
  line-height: 28px;
}
.data > h3 {
  font-size: 22px;
  font-weight: 600;
  margin-bottom: 40px;
}

.Reserve {
  text-align: center;
  padding: 50px 0;
}
.Reserve > h2 {
  margin-top: 50px;
  margin-bottom: 30px;
  font-size: 37px;
}

.pay {
  padding: 50px 0;
}
.map {
  text-align: center;
  margin-bottom: 100px !important;
}
.name {
  margin-top: 150px;
}
.position {
  text-align: left;
  padding: 5% 0;
}
.position > img {
  width: 77%;
}


h1,
h2,
h3,
h4,
h5,
button,
a {
  font-family: "chinaGenSenMaruGothicTW-Bold";
}

p,
span,
div {
  font-family: "chinaGenSenMaruGothicTW-Regular";
}
@media all and (max-width: 1200px) {
   .position {
    text-align: center;
    padding: 0;
  }
  .position > img {
    width: 90%;
  }
}
@media all and (max-width: 992px) {
  .hade {
    margin-top: 0;
  }
  .hade > a {
    font-size: 19px;
  }
  .success > h2 {
    font-size: 24px;
  }
  .time > h5 {
    font-size: 17px;
  }
  .clinic > h4 {
    font-size: 19px;
  }
  .clinic > p {
    font-size: 16px;
  }
  .data > h5 {
    font-size: 17px;
  }
  .data > p {
    font-size: 16px;
    line-height: 28px;
  }
  .data > h3 {
    font-size: 17px;
  }
  .position > img {
    width: 95%;
  }
  .row {
    background-color: #fff;
  }
  .success {
    background-color: #fff;
  }
}
@media all and (max-width: 570px) {
  
  .hade > a > img {
    width: 14px;
    height: 26px;
  }
  .hade > a {
    font-size: 18px;
  }

  .Reserve {
    padding: 0;
  }
  .pay {
    padding: 20px 0;
  }
  .name {
    margin-top: 60px;
  }
  .position {
    margin-bottom: 50px;
  }
  .position > img {
    width: 95%;
  }
}
</style>
